import { styled as styledMui } from "@mui/material/styles";

export const HighlightedText = styledMui("span")(({ theme }) => ({
  color: theme.palette.text.main,
  fontWeight: 600,
}));
